module.exports = __webpack_public_path__ + "static/media/IconEmailBottledGoose.eec11b79.png";